import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy shadow-lg py-2' : 'bg-navy/90 backdrop-blur-sm py-4'}`} data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="flex justify-between items-center" data-id="element-136">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-137">
            <a href="#" className="text-white font-heading font-bold text-2xl tracking-tight uppercase" data-id="element-138">
              Diers and Stark, <span className="text-accent" data-id="element-139">Inc.</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-140">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-white transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-141">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-accent hover:bg-red-700 text-white px-5 py-2.5 text-sm font-bold uppercase tracking-wider transition-colors duration-300 shadow-md" data-id="element-142">
              Request a Survey
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-143">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-300 hover:text-white p-2" aria-label="Toggle menu" data-id="element-144">
              {isMobileMenuOpen ? <X size={28} data-id="element-145" /> : <Menu size={28} data-id="element-146" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-navy border-t border-gray-800 absolute w-full" data-id="element-147">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-148">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-300 hover:text-white hover:bg-navy-light uppercase tracking-wider border-b border-gray-800/50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-149">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-150">
              <a href="#contact" className="block w-full text-center bg-accent hover:bg-red-700 text-white px-5 py-3 text-base font-bold uppercase tracking-wider transition-colors shadow-md" onClick={() => setIsMobileMenuOpen(false)} data-id="element-151">
                Request a Survey
              </a>
            </div>
          </div>
        </div>}
    </header>;
}